import './ScorecardVicePres.css';
import React, { useState, useEffect } from 'react';
import infoIcon from '../../info-icon-26px.png';
import spacerBlank from '../../spacer_blank.gif';



function ScorecardVicePres(props) {

    const showImages = true;
    const tip1 = 'Legislation that saved the IBEW’s Pension program as we know it.';
    const tip2 = 'Delivers tax credits with labor standards to support low-carbon energy projects, including carbon capture and nuclear energy.';
    const tip3 = 'Promotes domestic semiconductor manufacturing and facility construction, benefiting American workers and industry.';
    const tip4 = 'To provide for a responsible increase to the debt ceiling.';
    
    let wasAbsent=false;
    let newMember=false;
    
    if (props.member.vote1 =='Missed' || props.member.vote2=='Missed' || props.member.vote3=='Missed' || props.member.vote4=='Missed'){
        wasAbsent=true;
    }
    if(props.member.vote1 =='Missed' && props.member.vote2=='Missed' && props.member.vote3=='Missed' && props.member.vote4=='Missed'){
      newMember=true;
    }

    return (
        <div>
            <table className="outside-table"><tbody>
            <tr><td>{showImages ? <div className="clipzone"><img src={props.member.memImage} className="clipped" valign="top"></img></div> : <div></div>} </td></tr>
              <tr>
                <td>
                <table className="inside-table"><tbody>
                    <tr>
                      <td className="td-spacer"></td>
                      <td className="med-text">
                            <div>{props.member.memName}</div>
                            <div>{props.member.memNameSub}</div>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan='2'>
                        {newMember?
                          <table>
                              <tbody>
                                <tr>
                                  <td className="small-text">Please note that this is a vacant office or a newly elected Member of Congress. As the 118th Congress takes more legislative action, the IBEW will update the scorecard to reflect the voting record.</td>
                                </tr>
                              </tbody>
                          </table>
                        :    
                            <table><tbody>
                              <tr>
                                  <td className="small-text-gray">Cast the tie-breaking vote in the Senate on the following:</td>
                              </tr>
                              <tr>
                                  <td className="small-text">{props.member.vote1?'Butch-Lewis Emergency Pension Plan Relief Act of 2021':''}<div className={props.member.vote1?"tooltip":"tooltip hide-tip"}><img src={infoIcon}></img><span className="tooltiptext">{tip1}</span></div></td><td className={props.member.vote1=='Support'?'small-text-green': props.member.vote1=='NewMember'?'small-text-dark-gray':'small-text-red'}>{props.member.vote1=='Support'?'With IBEW': props.member.vote1=='Missed'? 'Absent*' : props.member.vote1=='Oppose'?'Against IBEW': props.member.vote1=='NewMember'?'Not in Office': ''}</td>
                              </tr>
                                <tr>
                                  <td className="small-text">{props.member.vote2?'Inflation Reduction Act of 2022':''}<div className={props.member.vote2?"tooltip":"tooltip hide-tip"}><img src={infoIcon}></img><span className="tooltiptext">{tip2}</span></div></td><td className={props.member.vote2=='Support'?'small-text-green':props.member.vote2=='NewMember'?'small-text-dark-gray':'small-text-red'}>{props.member.vote2=='Support'?'With IBEW': props.member.vote2=='Missed'? 'Absent*' : props.member.vote2=='Oppose' ? 'Against IBEW': props.member.vote2=='NewMember'?'Not in Office': ''}</td>
                                </tr>
                                <tr>
                                  <td colSpan='2'className={props.member.memGrade=='Score: 100%' || props.member.memGrade=='Score: 75%' || props.member.memGrade=='Score: 67%'?'scorecard-grade-green':'scorecard-grade-red'}>{props.member.memGrade}</td>
                                </tr>
                                <tr><td colSpan='2'>{
                                        newMember?'Please note that this is a vacant office or a newly elected Member of Congress. As the 118th Congress takes more legislative action, the IBEW will update the scorecard to reflect the voting record.'
                                        :wasAbsent?'*Reasons for absence are unknown to the IBEW. Please take this into consideration when evaluating your member of Congress.':''
                                  }</td></tr>
                              </tbody>
                              </table>
                          }     
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              </tbody>
            </table>
        </div>
    )
};

export default ScorecardVicePres;